import { compact, get, trim } from 'lodash-es';
import type { Leaves } from '../../utils';
import type { EntityAdminRecord } from './types';

/**
 * Single-entity edit drawer title: the entity ID (or custom display name), plus
 * `" > {child}"` when editing a child row.
 */
export function getEntityAdminEditDisplayName<TEntity extends EntityAdminRecord>({
  entity,
  entityIDField,
  childIDField,
  isChildRow,
  entityDisplayName,
  childEntityDisplayName,
}: {
  entity: TEntity;
  entityIDField: NoInfer<Leaves<TEntity>>;
  childIDField?: NoInfer<Leaves<TEntity>>;
  isChildRow: boolean;
  entityDisplayName?: string;
  childEntityDisplayName?: string;
}): string | undefined {
  const entityName = trim(entityDisplayName) || trim(get(entity, entityIDField)) || undefined;
  const childName = isChildRow
    ? trim(childEntityDisplayName) || (childIDField != null ? trim(get(entity, childIDField)) : undefined) || undefined
    : undefined;

  return compact([entityName, childName]).join(' > ') || undefined;
}
